import React from 'react';
import PropTypes from 'prop-types';
import MenuSection from '../menu/menusection';

class MenuTree extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
      const { data, clickHandler, squeeze } = this.props;
      
      return (
        <MenuSection 
            squeeze={squeeze}
            name='Deportētie'
            menuItems={data}
            clickItem={clickHandler}
        />
      );
  }
}

MenuTree.propTypes = {
  data: PropTypes.array.isRequired,
  clickHandler: PropTypes.func.isRequired,
  squeeze: PropTypes.bool,
}

export default MenuTree;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/menutree/index.js